import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import "./BookDemo.css";

export default function BookDemo() {
  const [state, handleSubmit] = useForm("xeokqaoe"); // Replace with your real Formspree ID

  return (
    <div className="book-demo-page">
      <form className="demo-form" onSubmit={handleSubmit}>
        <h2>Explore our All-in-One AI Assistant for Aesthetic Clinics with a fantastic demo</h2>

        <div className="form-row">
          <input type="text" name="first_name" placeholder="First Name" required />
          <input type="text" name="last_name" placeholder="Last Name" required />
        </div>

        <div className="form-row">
          <input type="text" name="clinic_name" placeholder="Clinic Name" required />
          <input type="text" name="phone" placeholder="Phone Number" />
        </div>

        <div className="form-row">
          <input type="text" name="website" placeholder="Clinic Website" />
        </div>

        <div className="form-row">
          <input type="email" name="email" placeholder="Email" required />
        </div>

        <label className="checkbox">
          <input type="checkbox" name="agreed" required />
          I agree to the Olumis AI <a href="/privacy-policy" target="_blank">Privacy Policy</a>
        </label>

        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <ValidationError prefix="Message" field="message" errors={state.errors} />

        {state.succeeded ? (
          <p className="response-message">✅ Your request has been received. We’ll be in touch shortly!</p>
        ) : (
          <button type="submit" disabled={state.submitting}>
            {state.submitting ? "Submitting..." : "Submit"}
          </button>
        )}
      </form>

      <div className="demo-benefits">
        <img src="/logo.png" alt="Olumis AI Logo" className="demo-logo" />
        <ul>
          <li>✅ AI Powered Assistant</li>
          <li>✅ Smart Scheduling System</li>
          <li>✅ CRM system</li>
          <li>✅ Interactive Dashboard</li>
        </ul>
      </div>
    </div>
  );
}
